import type { AnchorHTMLAttributes, ReactNode } from "react";
import { REGISTER_URL } from "../constants";
import { trackRegisterClick } from "../lib/analytics";

type RegisterLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  source: string;
  label?: string;
  children: ReactNode;
};

export function RegisterLink({
  source,
  label,
  children,
  href = REGISTER_URL,
  onClick,
  ...props
}: RegisterLinkProps) {
  return (
    <a
      href={href}
      onClick={(event) => {
        trackRegisterClick(source, label);
        onClick?.(event);
      }}
      {...props}
    >
      {children}
    </a>
  );
}
